var bighouse = bighouse || {};

bighouse.searchNoResults = (function () {

    var noResultsLookup = [];

    function init() {

        $('.SearchFilters-group h4').each(function(){
            var self = this;

            if( $(self)[0].hasAttribute('data-name') ){
                var names = $(self).attr('data-name').split('|');
                var label = $(self).text();
                var divider = $(self).attr('data-divider');
                
                $(names).each(function(){
                    noResultsLookup[ this ] = {"label" : label, "divider" : divider};
                });
            }
       });

       updateNoResults($('#searchfilters').find('input').not('.js-filterAll'));
    }


    function updateNoResults(form){


        var noResultsArr = [];

        if(bighouse.searchFilters.checkin.date !== "")
            noResultsArr['Checkin date'] = bighouse.searchFilters.checkin.date;

        if(bighouse.searchFilters.checkin.nights !== "-1")
            noResultsArr['No of nights'] = bighouse.searchFilters.checkin.nights;

        for(var i=0; i<form.length; i++){

            if( $(form[i]).prop('checked') || $(form[i]).attr('type') !== 'checkbox' ){
               var inputName =  $(form[i]).attr('name');
                
                var value = $(form[i]).parents('label').text().trim();                
                if (value.length === 0) value = $(form[i]).val();

                var label = noResultsLookup[inputName].label;

                if( noResultsArr[label] ){
                    noResultsArr[label] += noResultsLookup[inputName].divider + value;
                } else {
                    noResultsArr[label] = value;
                }
            }
        }

        var noResultsStr = '';
        for (var key in noResultsArr){
            noResultsStr += key + ': ' + noResultsArr[key] + '\n';
        }

        $('.js-searchNoResultsTextarea').val(noResultsStr);
    }






    return {
        init: init,
        updateNoResults: updateNoResults
    };
})();